export const raspberry = {
  meta: {
    name: 'Raspberry'
  },
  layout: {
    content: {
      border: {
        left: '0'
      },
      boxShadow: '0 0 4px rgba(0, 0, 0, .1)'
    }
  },
  sidebar: {
    background: {
      color: '#a00937'
    },
    box: {
      shadow: 'inset 0 -15px 0 0 #a00937'
    },
    divider: {
      color: '#d42056'
    },
    header: {
      border: {
        bottom: '1px solid var(--sidebar-divider-color)'
      },
      height: '110px',

      badge: {
        backgroundColor: '#d42056',
        color: 'var(--color-white)'
      }
    },
    section: {
      heading: {
        color: {
          _: '#f07c9f',
          hover: '#ff437c',
          active: 'var(--color-white)'
        },
        icon: {
          background: {
            color: {
              active: '#860026'
            }
          },
          color: {
            _: '#d42056',
            active: 'var(--color-white)'
          }
        }
      },
      items: {
        border: {
          left: '2px solid #860026'
        },
        active: {
          item: {
            color: '#ff437c'
          }
        }
      },
      item: {
        backgroundColor: {
          active: '#860026',
          hover: 'rgba(255, 255, 255, .03)'
        },
        color: {
          _: '#f07c9f',
          hover: '#ff437c',
          active: 'var(--color-white)'
        }
      }
    },
    user: {
      background: {
        color: '#860026'
      },
      name: {
        color: '#f07c9f'
      },
      company: {
        color: '#fff'
      },
      trigger: {
        backgroundColor: '#a71944',
        color: 'var(--color-white)'
      }
    }
  },
  filter: {
    container: {
      background: {
        color: 'var(--color-red-0)'
      },
      border: {
        color: 'var(--color-red-200)'
      },
      color: 'var(--color-red-500)'
    },
    count: {
      background: {
        color: 'var(--color-white)'
      },
      border: {
        color: 'var(--color-red-200)'
      },
      color: 'var(--color-red-500)'
    }
  }
};
